<template>
  <div class="page-wrapper">
    <Header :active-nav="activeNav" @nav-click="handleNavClick" />

    <div class="page-content"></div>

    <Footer @scroll-to="handleScrollTo" @show-product="handleShowProduct" />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "PageName",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      activeNav: "page-name",
    };
  },
  mounted() {
    this.initScroll();
  },
  methods: {
    initScroll() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    handleNavClick(sectionId) {
      if (sectionId === "home") {
        this.$router.push({ name: "Home", hash: `#${sectionId}` });
      } else {
        this.$router.push({
          name: sectionId.charAt(0).toUpperCase() + sectionId.slice(1),
        });
      }
    },
    handleScrollTo(sectionId) {
      if (this.$route.name === "Home") {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      } else {
        this.$router.push({ name: "Home", hash: `#${sectionId}` });
      }
    },
    handleShowProduct(id) {
      this.$router.push({ name: "ProductDetail", params: { id } });
    },
  },
};
</script>

<style scoped></style>
